import AppUtils from "../../../../Utils/utils"
import { formatCount, formatMoney, formatRate, PROGRAMS } from "./programLimits"

const compact = (value) => AppUtils.convertNumber(Number(value ?? 0), 1)

const LINE_BUILDERS = {
  [PROGRAMS.VAMP]: (month) => [
    formatRate(month?.vamp_rate),
    `${formatCount(month?.vamp_count)} incidents`,
    `${compact(month?.transaction_count)} payments`
  ],
  [PROGRAMS.ECP]: (month) => [
    formatRate(month?.chargeback_rate),
    `${formatCount(month?.chargeback_count)} chargebacks`,
    `${compact(month?.transaction_count)} payments`
  ],
  [PROGRAMS.EFM]: (month) => [
    formatRate(month?.fraud_rate),
    formatMoney(month?.net_fraud_volume),
    `${formatRate(month?.three_ds_usage_rate)} 3DS`
  ]
}

export const getMonthCellLines = ({ program, month }) => LINE_BUILDERS[program](month)
